/**
 * Scroll Related Functions + Handlers
 *
 * @author Industry at Delete
 * @see    https://github.com/industryatdelete
 */
jQuery(document).ready(function($) {


    /*
     * Affix Sidebar On Scroll
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    if ($('body').hasClass('single') || $('body').hasClass('page')) {
        
        $(function() {

            // the sidebar tp affix
            var sidebar = $('.sidebar');

            if (sidebar.length) {
                
                // get the heights and offset of elements we are to fix
                var sidebarHeight = sidebar.find('.inner').innerHeight();
                var contentHeight = sidebar.prev().innerHeight();
                var contentOffset = sidebar.prev().offset().top;
                
                if (contentHeight > (sidebarHeight - 30) && $(window).width() > 992) {
                    
                    // determine the starting position of the element we want to fix
                    var sidebarToTop  = sidebar.offset().top;
                    var offsetLeft    = sidebar.offset().left;
                    var sidebarWidth  = sidebar.innerWidth();

                    $(document).scroll(function() {
                        
                        // get the scrollTop() value
                        var scrolltop = $(this).scrollTop() + sidebarHeight;
                        // get the total amount the user has
                        // scrolled the document in pixels
                        var scrollPosY = $(document).scrollTop();
                        
                        // check whether the user has scrolled past
                        // position of the element we want to affix
                        if (scrollPosY >= sidebarToTop) {
                            
                            // if so make the element stuck on the page
                            // and not scroll with the rest of the page
                            sidebar.addClass('affix').css({
                                left: offsetLeft, 
                                width: sidebarWidth
                            });

                            if (scrolltop >= (contentHeight + contentOffset)) {
                                sidebar.removeClass('affix').removeAttr('style').css({
                                    position: 'absolute', 
                                    bottom: '30px', 
                                    right: '0'
                                });
                            } else {
                                sidebar.removeAttr('style').addClass('affix').css({
                                    left: offsetLeft, 
                                    width: sidebarWidth
                                });
                            }
                        } else {
                            // if not ... make the element scroll
                            // with the rest of the page, as usual.
                            sidebar.removeClass('affix').removeAttr('style');
                        }
                    });

                    $(window).resize(function() {
                        
                        // remove set styles + classes on initial resize
                        sidebar.removeClass('affix').removeAttr('style');

                        // recalculate our variables
                        var sidebarToTop  = sidebar.offset().top,
                            offsetLeft    = sidebar.offset().left,
                            sidebarWidth  = sidebar.innerWidth();

                        $(document).scroll(function() {
                            
                            // get the scrollTop() value
                            var scrolltop = $(this).scrollTop() + sidebarHeight;
                            // get the total amount the user has
                            // scrolled the document in pixels
                            var scrollPosY = $(document).scrollTop();
                            
                            // check whether the user has scrolled past
                            // position of the element we want to affix
                            if (scrollPosY >= sidebarToTop) {
                                
                                // if so make the element stuck on the page
                                // and not scroll with the rest of the page
                                sidebar.addClass('affix').css({
                                    left: offsetLeft, 
                                    width: sidebarWidth
                                });

                                if (scrolltop >= (contentHeight + contentOffset)) {
                                    sidebar.removeClass('affix').removeAttr('style').css({
                                        position: 'absolute', 
                                        bottom: '30px', 
                                        right: '0'
                                    });
                                } else {
                                    sidebar.removeAttr('style').addClass('affix').css({
                                        left: offsetLeft, 
                                        width: sidebarWidth
                                    });
                                }
                            } else {
                                // if not ... make the element scroll
                                // with the rest of the page, as usual.
                                sidebar.removeClass('affix').removeAttr('style');
                            }
                        });
                    });
                }
            }
        });
    }
});